//#region src/kiosk_payment_terminal_state.ts
var KioskPaymentTerminalState = /* @__PURE__ */ function(KioskPaymentTerminalState) {
	KioskPaymentTerminalState[KioskPaymentTerminalState["STOPPED"] = 0] = "STOPPED";
	KioskPaymentTerminalState[KioskPaymentTerminalState["INITIALIZING"] = 1] = "INITIALIZING";
	KioskPaymentTerminalState[KioskPaymentTerminalState["TERMINAL_SELECTION"] = 2] = "TERMINAL_SELECTION";
	KioskPaymentTerminalState[KioskPaymentTerminalState["WAITING_FOR_TERMINAL"] = 3] = "WAITING_FOR_TERMINAL";
	KioskPaymentTerminalState[KioskPaymentTerminalState["CONNECTING"] = 4] = "CONNECTING";
	KioskPaymentTerminalState[KioskPaymentTerminalState["UPDATING"] = 5] = "UPDATING";
	KioskPaymentTerminalState[KioskPaymentTerminalState["READY"] = 6] = "READY";
	KioskPaymentTerminalState[KioskPaymentTerminalState["TRANSACTION"] = 7] = "TRANSACTION";
	return KioskPaymentTerminalState;
}(KioskPaymentTerminalState || {});
//#endregion
export { KioskPaymentTerminalState };

//# sourceMappingURL=kiosk_payment_terminal_state.js.map